import { Pill } from '@/components/ui/pill/pill.component';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover/popover.component';
import { DesignObligation, ProductBuildingBlock } from '@/gql/graphql';
import { useState } from 'react';

interface PillRowProps {
  questionId: string;
  designObligations: DesignObligation[];
  buildingBlocks: ProductBuildingBlock[];
}

export const PillRow = ({ questionId, designObligations, buildingBlocks }: PillRowProps) => {
  const [popoverOpened, setPopoverOpened] = useState(false);

  const pills = [...designObligations, ...buildingBlocks];
  const totalPills = pills.length;

  const handleMouseEnter = () => {
    setPopoverOpened(true);
  };

  const handleMouseLeave = () => {
    setPopoverOpened(false);
  };

  return (
    <>
      {pills.map((pill, index) => {
        if (index > 2) return null;
        return (
          <Pill
            key={pill.id}
            variant={pill.__typename === 'DesignObligation' ? 'do' : 'bb'}
            text={pill.name || ''}
            data-testid={
              pill.__typename === 'DesignObligation'
                ? `question-${questionId}-input-tailored-design-obligation-${pill.id}`
                : `question-${questionId}-input-tailored-building-block-${pill.id}`
            }
          />
        );
      })}
      {totalPills > 3 && (
        <Popover open={popoverOpened}>
          <PopoverTrigger
            data-testid={`question-${questionId}-input-${questionId}-pill-trigger`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <Pill variant="neutral" text={`+${totalPills - 3}`} />
          </PopoverTrigger>
          <PopoverContent align="end" className="flex flex-col items-start gap-3 w-[360px]">
            {pills.map((pill, index) => {
              if (index < 3) return null;
              return (
                <Pill
                  key={pill.id}
                  variant={pill.__typename === 'DesignObligation' ? 'do' : 'bb'}
                  text={pill.name || ''}
                  data-testid={
                    pill.__typename === 'DesignObligation'
                      ? `question-${questionId}-input-tailored-design-obligation-${pill.id}`
                      : `question-${questionId}-input-tailored-building-block-${pill.id}`
                  }
                />
              );
            })}
          </PopoverContent>
        </Popover>
      )}
    </>
  );
};
